import { $ as e, A as t, At as n, Ct as r, Dt as i, Et as a, G as o, It as s, K as c, Mt as l, Nt as u, Ot as d, St as f, T as p, U as m, W as h, _t as g, ft as _, it as v, jt as y, kt as b, mt as x, ot as S, q as ee, wt as te, xt as C, yt as w } from "./dist-CkS8TOF-.js";
//#region ../../../node_modules/@codemirror/autocomplete/dist/index.js
var T = class {
	constructor(e, t, n, r) {
		this.state = e, this.pos = t, this.explicit = n, this.view = r, this.abortListeners = [], this.abortOnDocChange = !1;
	}
	tokenBefore(e) {
		let n = t(this.state).resolveInner(this.pos, -1);
		for (; n && e.indexOf(n.name) < 0;) n = n.parent;
		return n ? {
			from: n.from,
			to: this.pos,
			text: this.state.sliceDoc(n.from, this.pos),
			type: n.type
		} : null;
	}
	matchBefore(e) {
		let t = this.state.doc.lineAt(this.pos), n = Math.max(t.from, this.pos - 250), r = t.text.slice(n - t.from, this.pos - t.from), i = r.search(ae(e, !1));
		return i < 0 ? null : {
			from: n + i,
			to: this.pos,
			text: r.slice(i)
		};
	}
	get aborted() {
		return this.abortListeners == null;
	}
	addEventListener(e, t, n) {
		e == "abort" && this.abortListeners && (this.abortListeners.push(t), n && n.onDocChange && (this.abortOnDocChange = !0));
	}
};
function E(e) {
	let t = Object.keys(e).join(""), n = /\w/.test(t);
	return n && (t = t.replace(/\w/g, "")), `[${n ? "\\w" : ""}${t.replace(/[^\w\s]/g, "\\$&")}]`;
}
function ne(e) {
	let t = Object.create(null), n = Object.create(null);
	for (let { label: r } of e) {
		t[r[0]] = !0;
		for (let e = 1; e < r.length; e++) n[r[e]] = !0;
	}
	let r = E(t) + E(n) + "*$";
	return [RegExp("^" + r), new RegExp(r)];
}
function D(e) {
	let t = e.map((e) => typeof e == "string" ? { label: e } : e), [n, r] = t.every((e) => /^\w+$/.test(e.label)) ? [/\w*$/, /\w+$/] : ne(t);
	return (e) => {
		let i = e.matchBefore(r);
		return i || e.explicit ? {
			from: i ? i.from : e.pos,
			options: t,
			validFor: n
		} : null;
	};
}
function re(e, n) {
	return (r) => {
		for (let n = t(r.state).resolveInner(r.pos, -1); n; n = n.parent) {
			if (e.indexOf(n.name) > -1) return null;
			if (n.type.isTop) break;
		}
		return n(r);
	};
}
var ie = class {
	constructor(e, t, n, r) {
		this.completion = e, this.source = t, this.match = n, this.score = r;
	}
};
function O(e) {
	return e.selection.main.from;
}
function ae(e, t) {
	let { source: n } = e, r = t && n[0] != "^", i = n[n.length - 1] != "$";
	return !r && !i ? e : RegExp(`${r ? "^" : ""}(?:${n})${i ? "$" : ""}`, e.flags ?? (e.ignoreCase ? "i" : ""));
}
var k = /*@__PURE__*/ x.define();
function oe(e, t, n, r) {
	let { main: i } = e.selection, a = n - i.from, o = r - i.from;
	return {
		...e.changeByRange((s) => {
			if (s != i && n != r && e.sliceDoc(s.from + a, s.from + o) != e.sliceDoc(n, r)) return { range: s };
			let c = e.toText(t);
			return {
				changes: {
					from: s.from + a,
					to: r == i.from ? s.to : s.from + o,
					insert: c
				},
				range: w.cursor(s.from + a + c.length)
			};
		}),
		scrollIntoView: !0,
		userEvent: "input.complete"
	};
}
var se = /*@__PURE__*/ new WeakMap();
function ce(e) {
	if (!Array.isArray(e)) return e;
	let t = se.get(e);
	return t || se.set(e, t = D(e)), t;
}
var A = /*@__PURE__*/ i.define(), j = /*@__PURE__*/ i.define(), le = class {
	constructor(e) {
		this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
		for (let t = 0; t < e.length;) {
			let n = y(e, t), r = l(n);
			this.chars.push(n);
			let i = e.slice(t, t + r), a = i.toUpperCase();
			this.folded.push(y(a == i ? i.toLowerCase() : a, 0)), t += r;
		}
		this.astral = e.length != this.chars.length;
	}
	ret(e, t) {
		return this.score = e, this.matched = t, this;
	}
	match(e) {
		if (this.pattern.length == 0) return this.ret(-100, []);
		if (e.length < this.pattern.length) return null;
		let { chars: t, folded: n, any: r, precise: i, byWord: a } = this;
		if (t.length == 1) {
			let r = y(e, 0), i = l(r), a = i == e.length ? 0 : -100;
			if (r != t[0]) if (r == n[0]) a += -200;
			else return null;
			return this.ret(a, [0, i]);
		}
		let o = e.indexOf(this.pattern);
		if (o == 0) return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
		let c = t.length, u = 0;
		if (o < 0) {
			for (let i = 0, a = Math.min(e.length, 200); i < a && u < c;) {
				let a = y(e, i);
				(a == t[u] || a == n[u]) && (r[u++] = i), i += l(a);
			}
			if (u < c) return null;
		}
		let d = 0, f = 0, p = !1, m = 0, h = -1, g = -1, _ = /[a-z]/.test(e), v = !0;
		for (let r = 0, u = Math.min(e.length, 200), b = 0; r < u && f < c;) {
			let u = y(e, r);
			o < 0 && (d < c && u == t[d] && (i[d++] = r), m < c && (u == t[m] || u == n[m] ? (m == 0 && (h = r), g = r + 1, m++) : m = 0));
			let x, S = u < 255 ? u >= 48 && u <= 57 || u >= 97 && u <= 122 ? 2 : +(u >= 65 && u <= 90) : (x = s(u)) == x.toLowerCase() ? x == x.toUpperCase() ? 0 : 2 : 1;
			(!r || S == 1 && _ || b == 0 && S != 0) && (t[f] == u || n[f] == u && (p = !0) ? a[f++] = r : a.length && (v = !1)), b = S, r += l(u);
		}
		return f == c && a[0] == 0 && v ? this.result(-100 + (p ? -200 : 0), a, e) : m == c && h == 0 ? this.ret(-200 - e.length + (g == e.length ? 0 : -100), [0, g]) : o > -1 ? this.ret(-700 - e.length, [o, o + this.pattern.length]) : m == c ? this.ret(-900 - e.length, [h, g]) : f == c ? this.result(-100 + (p ? -200 : 0) + -700 + (v ? 0 : -1100), a, e) : t.length == 2 ? null : this.result((r[0] ? -700 : 0) + -200 + -1100, r, e);
	}
	result(e, t, n) {
		let r = [], i = 0;
		for (let e of t) {
			let t = e + (this.astral ? l(y(n, e)) : 1);
			i && r[i - 1] == e ? r[i - 1] = t : (r[i++] = e, r[i++] = t);
		}
		return this.ret(e - n.length, r);
	}
}, ue = class {
	constructor(e) {
		this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
	}
	match(e) {
		if (e.length < this.pattern.length) return null;
		let t = e.slice(0, this.pattern.length), n = t == this.pattern ? 0 : t.toLowerCase() == this.folded ? -200 : null;
		return n == null ? null : (this.matched = [0, t.length], this.score = n + (e.length == this.pattern.length ? 0 : -100), this);
	}
}, M = /*@__PURE__*/ C.define({ combine(e) {
	return u(e, {
		activateOnTyping: !0,
		activateOnCompletion: () => !1,
		activateOnTypingDelay: 100,
		selectOnOpen: !0,
		override: null,
		closeOnBlur: !0,
		maxRenderedOptions: 100,
		defaultKeymap: !0,
		tooltipClass: () => "",
		optionClass: () => "",
		aboveCursor: !1,
		icons: !0,
		addToOptions: [],
		positionInfo: de,
		filterStrict: !1,
		compareCompletions: (e, t) => (e.sortText || e.label).localeCompare(t.sortText || t.label),
		interactionDelay: 75,
		updateSyncTime: 100
	}, {
		defaultKeymap: (e, t) => e && t,
		closeOnBlur: (e, t) => e && t,
		icons: (e, t) => e && t,
		tooltipClass: (e, t) => (n) => N(e(n), t(n)),
		optionClass: (e, t) => (n) => N(e(n), t(n)),
		addToOptions: (e, t) => e.concat(t),
		filterStrict: (e, t) => e || t
	});
} });
function N(e, t) {
	return e ? t ? e + " " + t : e : t;
}
function de(e, t, n, r, i, a) {
	let o = e.textDirection == h.RTL, s = o, c = !1, l = "top", u, d, f = t.left - i.left, p = i.right - t.right, m = r.right - r.left, g = r.bottom - r.top;
	if (s && f < Math.min(m, p) ? s = !1 : !s && p < Math.min(m, f) && (s = !0), m <= (s ? f : p)) u = Math.max(i.top, Math.min(n.top, i.bottom - g)) - t.top, d = Math.min(400, s ? f : p);
	else {
		c = !0, d = Math.min(400, (o ? t.right : i.right - t.left) - 30);
		let e = i.bottom - t.bottom;
		e >= g || e > t.top ? u = n.bottom - t.top : (l = "bottom", u = t.bottom - n.top);
	}
	let _ = (t.bottom - t.top) / a.offsetHeight, v = (t.right - t.left) / a.offsetWidth;
	return {
		style: `${l}: ${u / _}px; max-width: ${d / v}px`,
		class: "cm-completionInfo-" + (c ? o ? "left-narrow" : "right-narrow" : s ? "left" : "right")
	};
}
var P = /*@__PURE__*/ i.define();
function fe(e) {
	let t = e.addToOptions.slice();
	return e.icons && t.push({
		render(e) {
			let t = document.createElement("div");
			return t.classList.add("cm-completionIcon"), e.type && t.classList.add(...e.type.split(/\s+/g).map((e) => "cm-completionIcon-" + e)), t.setAttribute("aria-hidden", "true"), t;
		},
		position: 20
	}), t.push({
		render(e, t, n, r) {
			let i = document.createElement("span");
			i.className = "cm-completionLabel";
			let a = e.displayLabel || e.label, o = 0;
			for (let e = 0; e < r.length;) {
				let t = r[e++], n = r[e++];
				t > o && i.appendChild(document.createTextNode(a.slice(o, t)));
				let s = i.appendChild(document.createElement("span"));
				s.appendChild(document.createTextNode(a.slice(t, n))), s.className = "cm-completionMatchedText", o = n;
			}
			return o < a.length && i.appendChild(document.createTextNode(a.slice(o))), i;
		},
		position: 50
	}, {
		render(e) {
			if (!e.detail) return null;
			let t = document.createElement("span");
			return t.className = "cm-completionDetail", t.textContent = e.detail, t;
		},
		position: 80
	}), t.sort((e, t) => e.position - t.position).map((e) => e.render);
}
function F(e, t, n) {
	if (e <= n) return {
		from: 0,
		to: e
	};
	if (t < 0 && (t = 0), t <= e >> 1) {
		let e = Math.floor(t / n);
		return {
			from: e * n,
			to: (e + 1) * n
		};
	}
	let r = Math.ceil((e - t) / n);
	return {
		from: e - r * n,
		to: e - (r - 1) * n
	};
}
var pe = class {
	constructor(e, t, n) {
		this.view = e, this.stateField = t, this.applyCompletion = n, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
			read: () => this.measureInfo(),
			write: (e) => this.placeInfo(e),
			key: this
		}, this.space = null, this.currentClass = "";
		let r = e.state.field(t), { options: i, selected: a } = r.open, o = e.state.facet(M);
		this.optionContent = fe(o), this.optionClass = o.optionClass, this.tooltipClass = o.tooltipClass, this.range = F(i.length, a, o.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (n) => {
			let { options: r } = e.state.field(t).open;
			for (let t = n.target, i; t && t != this.dom; t = t.parentNode) if (t.nodeName == "LI" && (i = /-(\d+)$/.exec(t.id)) && +i[1] < r.length) {
				this.applyCompletion(e, r[+i[1]]), n.preventDefault();
				return;
			}
			if (n.target == this.list) {
				let t = this.list.classList.contains("cm-completionListIncompleteTop") && n.clientY < this.list.firstChild.getBoundingClientRect().top ? this.range.from - 1 : this.list.classList.contains("cm-completionListIncompleteBottom") && n.clientY > this.list.lastChild.getBoundingClientRect().bottom ? this.range.to : null;
				t != null && (e.dispatch({ effects: P.of(t) }), n.preventDefault());
			}
		}), this.dom.addEventListener("focusout", (t) => {
			let n = e.state.field(this.stateField, !1);
			n && n.tooltip && e.state.facet(M).closeOnBlur && t.relatedTarget != e.contentDOM && e.dispatch({ effects: j.of(null) });
		}), this.showOptions(i, r.id);
	}
	mount() {
		this.updateSel();
	}
	showOptions(e, t) {
		this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", () => {
			this.info && this.view.requestMeasure(this.placeInfoReq);
		});
	}
	update(e) {
		let t = e.state.field(this.stateField), n = e.startState.field(this.stateField);
		if (this.updateTooltipClass(e.state), t != n) {
			let { options: r, selected: i, disabled: a } = t.open;
			(!n.open || n.open.options != r) && (this.range = F(r.length, i, e.state.facet(M).maxRenderedOptions), this.showOptions(r, t.id)), this.updateSel(), a != n.open?.disabled && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
		}
	}
	updateTooltipClass(e) {
		let t = this.tooltipClass(e);
		if (t != this.currentClass) {
			for (let e of this.currentClass.split(" ")) e && this.dom.classList.remove(e);
			for (let e of t.split(" ")) e && this.dom.classList.add(e);
			this.currentClass = t;
		}
	}
	positioned(e) {
		this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
	}
	updateSel() {
		let e = this.view.state.field(this.stateField), t = e.open;
		(t.selected > -1 && t.selected < this.range.from || t.selected >= this.range.to) && (this.range = F(t.options.length, t.selected, this.view.state.facet(M).maxRenderedOptions), this.showOptions(t.options, e.id));
		let n = this.updateSelectedOption(t.selected);
		if (n) {
			this.destroyInfo();
			let { completion: r } = t.options[t.selected], { info: i } = r;
			if (!i) return;
			let a = typeof i == "string" ? document.createTextNode(i) : i(r);
			if (!a) return;
			"then" in a ? a.then((t) => {
				t && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(t, r);
			}).catch((e) => S(this.view.state, e, "completion info")) : (this.addInfoPane(a, r), n.setAttribute("aria-describedby", this.info.id));
		}
	}
	addInfoPane(e, t) {
		this.destroyInfo();
		let n = this.info = document.createElement("div");
		if (n.className = "cm-tooltip cm-completionInfo", n.id = "cm-completionInfo-" + Math.floor(Math.random() * 65535).toString(16), e.nodeType != null) n.appendChild(e), this.infoDestroy = null;
		else {
			let { dom: t, destroy: r } = e;
			n.appendChild(t), this.infoDestroy = r || null;
		}
		this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq);
	}
	updateSelectedOption(e) {
		let t = null;
		for (let n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++) n.nodeName != "LI" || !n.id ? r-- : r == e ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), t = n) : n.hasAttribute("aria-selected") && (n.removeAttribute("aria-selected"), n.removeAttribute("aria-describedby"));
		return t && he(this.list, t), t;
	}
	measureInfo() {
		let e = this.dom.querySelector("[aria-selected]");
		if (!e || !this.info) return null;
		let t = this.dom.getBoundingClientRect(), n = this.info.getBoundingClientRect(), r = e.getBoundingClientRect(), i = this.space;
		if (!i) {
			let e = this.dom.ownerDocument.documentElement;
			i = {
				left: 0,
				top: 0,
				right: e.clientWidth,
				bottom: e.clientHeight
			};
		}
		return r.top > Math.min(i.bottom, t.bottom) - 10 || r.bottom < Math.max(i.top, t.top) + 10 ? null : this.view.state.facet(M).positionInfo(this.view, t, r, n, i, this.dom);
	}
	placeInfo(e) {
		this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
	}
	createListBox(e, t, n) {
		let r = document.createElement("ul");
		r.id = t, r.setAttribute("role", "listbox"), r.setAttribute("aria-expanded", "true"), r.setAttribute("aria-label", this.view.state.phrase("Completions")), r.addEventListener("mousedown", (e) => {
			e.target == r && e.preventDefault();
		});
		let i = null;
		for (let a = n.from; a < n.to; a++) {
			let { completion: o, match: s } = e[a], { section: c } = o;
			if (c) {
				let e = typeof c == "string" ? c : c.name;
				if (e != i && (a > n.from || n.from == 0)) if (i = e, typeof c != "string" && c.header) r.appendChild(c.header(c));
				else {
					let t = r.appendChild(document.createElement("completion-section"));
					t.textContent = e;
				}
			}
			let l = r.appendChild(document.createElement("li"));
			l.id = t + "-" + a, l.setAttribute("role", "option");
			let u = this.optionClass(o);
			u && (l.className = u);
			for (let e of this.optionContent) {
				let t = e(o, this.view.state, this.view, s);
				t && l.appendChild(t);
			}
		}
		return n.from && r.classList.add("cm-completionListIncompleteTop"), n.to < e.length && r.classList.add("cm-completionListIncompleteBottom"), r;
	}
	destroyInfo() {
		this.info &&= (this.infoDestroy && this.infoDestroy(), this.info.remove(), null);
	}
	destroy() {
		this.destroyInfo();
	}
};
function me(e, t) {
	return (n) => new pe(n, e, t);
}
function he(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.height / e.offsetHeight;
	r.top < n.top ? e.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / i);
}
function ge(e) {
	return (e.boost || 0) * 100 + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + +!!e.type;
}
function _e(e, t) {
	let n = [], r = null, i = null, a = (e) => {
		n.push(e);
		let { section: t } = e.completion;
		if (t) {
			r ||= [];
			let e = typeof t == "string" ? t : t.name;
			r.some((t) => t.name == e) || r.push(typeof t == "string" ? { name: e } : t);
		}
	}, o = t.facet(M);
	for (let r of e) if (r.hasResult()) {
		let e = r.result.getMatch;
		if (r.result.filter === !1) for (let t of r.result.options) a(new ie(t, r.source, e ? e(t) : [], 1e9 - n.length));
		else {
			let n = t.sliceDoc(r.from, r.to), s, c = o.filterStrict ? new ue(n) : new le(n);
			for (let t of r.result.options) if (s = c.match(t.label)) {
				let n = t.displayLabel ? e ? e(t, s.matched) : [] : s.matched, o = s.score + (t.boost || 0);
				if (a(new ie(t, r.source, n, o)), typeof t.section == "object" && t.section.rank === "dynamic") {
					let { name: e } = t.section;
					i ||= Object.create(null), i[e] = Math.max(o, i[e] || -1e9);
				}
			}
		}
	}
	if (r) {
		let e = Object.create(null), t = 0, a = (e, t) => (e.rank === "dynamic" && t.rank === "dynamic" ? i[t.name] - i[e.name] : 0) || (typeof e.rank == "number" ? e.rank : 1e9) - (typeof t.rank == "number" ? t.rank : 1e9) || (e.name < t.name ? -1 : 1);
		for (let n of r.sort(a)) t -= 1e5, e[n.name] = t;
		for (let t of n) {
			let { section: n } = t.completion;
			n && (t.score += e[typeof n == "string" ? n : n.name]);
		}
	}
	let s = [], c = null, l = o.compareCompletions;
	for (let e of n.sort((e, t) => t.score - e.score || l(e.completion, t.completion))) {
		let t = e.completion;
		!c || c.label != t.label || c.detail != t.detail || c.type != null && t.type != null && c.type != t.type || c.apply != t.apply || c.boost != t.boost ? s.push(e) : ge(e.completion) > ge(c) && (s[s.length - 1] = e), c = e.completion;
	}
	return s;
}
var ve = class e {
	constructor(e, t, n, r, i, a) {
		this.options = e, this.attrs = t, this.tooltip = n, this.timestamp = r, this.selected = i, this.disabled = a;
	}
	setSelected(t, n) {
		return t == this.selected || t >= this.options.length ? this : new e(this.options, Ce(n, t), this.tooltip, this.timestamp, t, this.disabled);
	}
	static build(t, n, r, i, a, o) {
		if (i && !o && t.some((e) => e.isPending)) return i.setDisabled();
		let s = _e(t, n);
		if (!s.length) return i && t.some((e) => e.isPending) ? i.setDisabled() : null;
		let c = n.facet(M).selectOnOpen ? 0 : -1;
		if (i && i.selected != c && i.selected != -1) {
			let e = i.options[i.selected].completion;
			for (let t = 0; t < s.length; t++) if (s[t].completion == e) {
				c = t;
				break;
			}
		}
		return new e(s, Ce(r, c), {
			pos: t.reduce((e, t) => t.hasResult() ? Math.min(e, t.from) : e, 1e8),
			create: De,
			above: a.aboveCursor
		}, i ? i.timestamp : Date.now(), c, !1);
	}
	map(t) {
		return new e(this.options, this.attrs, {
			...this.tooltip,
			pos: t.mapPos(this.tooltip.pos)
		}, this.timestamp, this.selected, this.disabled);
	}
	setDisabled() {
		return new e(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
	}
}, ye = class e {
	constructor(e, t, n) {
		this.active = e, this.id = t, this.open = n;
	}
	static start() {
		return new e(we, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
	}
	update(t) {
		let { state: n } = t, r = n.facet(M), i = (r.override || n.languageDataAt("autocomplete", O(n)).map(ce)).map((e) => (this.active.find((t) => t.source == e) || new I(e, +!!this.active.some((e) => e.state != 0))).update(t, r));
		i.length == this.active.length && i.every((e, t) => e == this.active[t]) && (i = this.active);
		let a = this.open, o = t.effects.some((e) => e.is(R));
		a && t.docChanged && (a = a.map(t.changes)), t.selection || i.some((e) => e.hasResult() && t.changes.touchesRange(e.from, e.to)) || !be(i, this.active) || o ? a = ve.build(i, n, this.id, a, r, o) : a && a.disabled && !i.some((e) => e.isPending) && (a = null), !a && i.every((e) => !e.isPending) && i.some((e) => e.hasResult()) && (i = i.map((e) => e.hasResult() ? new I(e.source, 0) : e));
		for (let e of t.effects) e.is(P) && (a &&= a.setSelected(e.value, this.id));
		return i == this.active && a == this.open ? this : new e(i, this.id, a);
	}
	get tooltip() {
		return this.open ? this.open.tooltip : null;
	}
	get attrs() {
		return this.open ? this.open.attrs : this.active.length ? xe : Se;
	}
};
function be(e, t) {
	if (e == t) return !0;
	for (let n = 0, r = 0;;) {
		for (; n < e.length && !e[n].hasResult();) n++;
		for (; r < t.length && !t[r].hasResult();) r++;
		let i = n == e.length, a = r == t.length;
		if (i || a) return i == a;
		if (e[n++].result != t[r++].result) return !1;
	}
}
var xe = { "aria-autocomplete": "list" }, Se = {};
function Ce(e, t) {
	let n = {
		"aria-autocomplete": "list",
		"aria-haspopup": "listbox",
		"aria-controls": e
	};
	return t > -1 && (n["aria-activedescendant"] = e + "-" + t), n;
}
var we = [];
function Te(e, t) {
	if (e.isUserEvent("input.complete")) {
		let n = e.annotation(k);
		if (n && t.activateOnCompletion(n)) return 12;
	}
	let n = e.isUserEvent("input.type");
	return n && t.activateOnTyping ? 5 : n ? 1 : e.isUserEvent("delete.backward") ? 2 : e.selection ? 8 : e.docChanged ? 16 : 0;
}
var I = class e {
	constructor(e, t, n = !1) {
		this.source = e, this.state = t, this.explicit = n;
	}
	hasResult() {
		return !1;
	}
	get isPending() {
		return this.state == 1;
	}
	update(t, n) {
		let r = Te(t, n), i = this;
		(r & 8 || r & 16 && this.touches(t)) && (i = new e(i.source, 0)), r & 4 && i.state == 0 && (i = new e(this.source, 1)), i = i.updateFor(t, r);
		for (let n of t.effects) if (n.is(A)) i = new e(i.source, 1, n.value);
		else if (n.is(j)) i = new e(i.source, 0);
		else if (n.is(R)) for (let e of n.value) e.source == i.source && (i = e);
		return i;
	}
	updateFor(e, t) {
		return this.map(e.changes);
	}
	map(e) {
		return this;
	}
	touches(e) {
		return e.changes.touchesRange(O(e.state));
	}
}, L = class e extends I {
	constructor(e, t, n, r, i, a) {
		super(e, 3, t), this.limit = n, this.result = r, this.from = i, this.to = a;
	}
	hasResult() {
		return !0;
	}
	updateFor(t, n) {
		if (!(n & 3)) return this.map(t.changes);
		let r = this.result;
		r.map && !t.changes.empty && (r = r.map(r, t.changes));
		let i = t.changes.mapPos(this.from), a = t.changes.mapPos(this.to, 1), o = O(t.state);
		if (o > a || !r || n & 2 && (O(t.startState) == this.from || o < this.limit)) return new I(this.source, n & 4 ? 1 : 0);
		let s = t.changes.mapPos(this.limit);
		return Ee(r.validFor, t.state, i, a) ? new e(this.source, this.explicit, s, r, i, a) : r.update && (r = r.update(r, i, a, new T(t.state, o, !1))) ? new e(this.source, this.explicit, s, r, r.from, r.to ?? O(t.state)) : new I(this.source, 1, this.explicit);
	}
	map(t) {
		if (t.empty) return this;
		let n = this.result.map ? this.result.map(this.result, t) : this.result;
		return n ? new e(this.source, this.explicit, t.mapPos(this.limit), n, t.mapPos(this.from), t.mapPos(this.to, 1)) : new I(this.source, 0);
	}
	touches(e) {
		return e.changes.touchesRange(this.from, this.to);
	}
};
function Ee(e, t, n, r) {
	if (!e) return !1;
	let i = t.sliceDoc(n, r);
	return typeof e == "function" ? e(i, n, r, t) : ae(e, !0).test(i);
}
var R = /*@__PURE__*/ i.define({ map(e, t) {
	return e.map((e) => e.map(t));
} }), z = /*@__PURE__*/ d.define({
	create() {
		return ye.start();
	},
	update(e, t) {
		return e.update(t);
	},
	provide: (e) => [_.from(e, (e) => e.tooltip), o.contentAttributes.from(e, (e) => e.attrs)]
});
function B(e, t) {
	let n = t.completion.apply || t.completion.label, r = e.state.field(z).active.find((e) => e.source == t.source);
	return r instanceof L ? (typeof n == "string" ? e.dispatch({
		...oe(e.state, n, r.from, r.to),
		annotations: k.of(t.completion)
	}) : n(e, t.completion, r.from, r.to), !0) : !1;
}
var De = /*@__PURE__*/ me(z, B);
function V(t, n = "option") {
	return (r) => {
		let i = r.state.field(z, !1);
		if (!i || !i.open || i.open.disabled || Date.now() - i.open.timestamp < r.state.facet(M).interactionDelay) return !1;
		let a = 1, o;
		n == "page" && (o = e(r, i.open.tooltip)) && (a = Math.max(2, Math.floor(o.dom.offsetHeight / o.dom.querySelector("li").offsetHeight) - 1));
		let { length: s } = i.open.options, c = i.open.selected > -1 ? i.open.selected + a * (t ? 1 : -1) : t ? 0 : s - 1;
		return c < 0 ? c = n == "page" ? 0 : s - 1 : c >= s && (c = n == "page" ? s - 1 : 0), r.dispatch({ effects: P.of(c) }), !0;
	};
}
var Oe = (e) => {
	let t = e.state.field(z, !1);
	return e.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < e.state.facet(M).interactionDelay ? !1 : B(e, t.open.options[t.open.selected]);
}, H = (e) => e.state.field(z, !1) ? (e.dispatch({ effects: A.of(!0) }), !0) : !1, ke = (e) => {
	let t = e.state.field(z, !1);
	return !t || !t.active.some((e) => e.state != 0) ? !1 : (e.dispatch({ effects: j.of(null) }), !0);
}, Ae = class {
	constructor(e, t) {
		this.active = e, this.context = t, this.time = Date.now(), this.updates = [], this.done = void 0;
	}
}, je = 50, Me = 1e3, Ne = /*@__PURE__*/ c.fromClass(class {
	constructor(e) {
		this.view = e, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
		for (let t of e.state.field(z).active) t.isPending && this.startQuery(t);
	}
	update(e) {
		let t = e.state.field(z), n = e.state.facet(M);
		if (!e.selectionSet && !e.docChanged && e.startState.field(z) == t) return;
		let r = e.transactions.some((e) => {
			let t = Te(e, n);
			return t & 8 || (e.selection || e.docChanged) && !(t & 3);
		});
		for (let t = 0; t < this.running.length; t++) {
			let n = this.running[t];
			if (r || n.context.abortOnDocChange && e.docChanged || n.updates.length + e.transactions.length > je && Date.now() - n.time > Me) {
				for (let e of n.context.abortListeners) try {
					e();
				} catch (e) {
					S(this.view.state, e);
				}
				n.context.abortListeners = null, this.running.splice(t--, 1);
			} else n.updates.push(...e.transactions);
		}
		this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), e.transactions.some((e) => e.effects.some((e) => e.is(A))) && (this.pendingStart = !0);
		let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
		if (this.debounceUpdate = t.active.some((e) => e.isPending && !this.running.some((t) => t.active.source == e.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0) for (let t of e.transactions) t.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && t.selection && (this.composing = 3);
	}
	startUpdate() {
		this.debounceUpdate = -1, this.pendingStart = !1;
		let { state: e } = this.view, t = e.field(z);
		for (let e of t.active) e.isPending && !this.running.some((t) => t.active.source == e.source) && this.startQuery(e);
		this.running.length && t.open && t.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(M).updateSyncTime));
	}
	startQuery(e) {
		let { state: t } = this.view, n = new T(t, O(t), e.explicit, this.view), r = new Ae(e, n);
		this.running.push(r), Promise.resolve(e.source(n)).then((e) => {
			r.context.aborted || (r.done = e || null, this.scheduleAccept());
		}, (e) => {
			this.view.dispatch({ effects: j.of(null) }), S(this.view.state, e);
		});
	}
	scheduleAccept() {
		this.running.every((e) => e.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(M).updateSyncTime));
	}
	accept() {
		this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
		let e = [], t = this.view.state.facet(M), n = this.view.state.field(z);
		for (let r = 0; r < this.running.length; r++) {
			let i = this.running[r];
			if (i.done === void 0) continue;
			if (this.running.splice(r--, 1), i.done) {
				let n = O(i.updates.length ? i.updates[0].startState : this.view.state), r = Math.min(n, i.done.from + +!i.active.explicit), a = new L(i.active.source, i.active.explicit, r, i.done, i.done.from, i.done.to ?? n);
				for (let e of i.updates) a = a.update(e, t);
				if (a.hasResult()) {
					e.push(a);
					continue;
				}
			}
			let a = n.active.find((e) => e.source == i.active.source);
			if (a && a.isPending) if (i.done == null) {
				let n = new I(i.active.source, 0);
				for (let e of i.updates) n = n.update(e, t);
				n.isPending || e.push(n);
			} else this.startQuery(a);
		}
		(e.length || n.open && n.open.disabled) && this.view.dispatch({ effects: R.of(e) });
	}
}, { eventHandlers: {
	blur(t) {
		let n = this.view.state.field(z, !1);
		if (n && n.tooltip && this.view.state.facet(M).closeOnBlur) {
			let r = n.open && e(this.view, n.open.tooltip);
			(!r || !r.dom.contains(t.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: j.of(null) }), 10);
		}
	},
	compositionstart() {
		this.composing = 1;
	},
	compositionend() {
		this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: A.of(!1) }), 20), this.composing = 0;
	}
} }), Pe = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform), Fe = /*@__PURE__*/ r.highest(/*@__PURE__*/ o.domEventHandlers({ keydown(e, t) {
	let n = t.state.field(z, !1);
	if (!n || !n.open || n.open.disabled || n.open.selected < 0 || e.key.length > 1 || e.ctrlKey && !(Pe && e.altKey) || e.metaKey) return !1;
	let r = n.open.options[n.open.selected], i = n.active.find((e) => e.source == r.source), a = r.completion.commitCharacters || i.result.commitCharacters;
	return a && a.indexOf(e.key) > -1 && B(t, r), !1;
} })), U = /*@__PURE__*/ o.baseTheme({
	".cm-tooltip.cm-tooltip-autocomplete": { "& > ul": {
		fontFamily: "monospace",
		whiteSpace: "nowrap",
		overflow: "hidden auto",
		maxWidth_fallback: "700px",
		maxWidth: "min(700px, 95vw)",
		minWidth: "250px",
		maxHeight: "10em",
		height: "100%",
		listStyle: "none",
		margin: 0,
		padding: 0,
		"& > li, & > completion-section": {
			padding: "1px 3px",
			lineHeight: 1.2
		},
		"& > li": {
			overflowX: "hidden",
			textOverflow: "ellipsis",
			cursor: "pointer"
		},
		"& > completion-section": {
			display: "list-item",
			borderBottom: "1px solid silver",
			paddingLeft: "0.5em",
			opacity: .7
		}
	} },
	"&light .cm-tooltip-autocomplete ul li[aria-selected]": {
		background: "#17c",
		color: "white"
	},
	"&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#777" },
	"&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
		background: "#347",
		color: "white"
	},
	"&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#444" },
	".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
		content: "\"···\"",
		opacity: .5,
		display: "block",
		textAlign: "center",
		cursor: "pointer"
	},
	".cm-tooltip.cm-completionInfo": {
		position: "absolute",
		padding: "3px 9px",
		width: "max-content",
		maxWidth: "400px",
		boxSizing: "border-box",
		whiteSpace: "pre-line"
	},
	".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
	".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
	".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
	".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
	"&light .cm-snippetField": { backgroundColor: "#00000022" },
	"&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
	".cm-snippetFieldPosition": {
		verticalAlign: "text-top",
		width: 0,
		height: "1.15em",
		display: "inline-block",
		margin: "0 -0.7px -.7em",
		borderLeft: "1.4px dotted #888"
	},
	".cm-completionMatchedText": { textDecoration: "underline" },
	".cm-completionDetail": {
		marginLeft: "0.5em",
		fontStyle: "italic"
	},
	".cm-completionIcon": {
		fontSize: "90%",
		width: ".8em",
		display: "inline-block",
		textAlign: "center",
		paddingRight: ".6em",
		opacity: "0.6",
		boxSizing: "content-box"
	},
	".cm-completionIcon-function, .cm-completionIcon-method": { "&:after": { content: "'ƒ'" } },
	".cm-completionIcon-class": { "&:after": { content: "'○'" } },
	".cm-completionIcon-interface": { "&:after": { content: "'◌'" } },
	".cm-completionIcon-variable": { "&:after": { content: "'𝑥'" } },
	".cm-completionIcon-constant": { "&:after": { content: "'𝐶'" } },
	".cm-completionIcon-type": { "&:after": { content: "'𝑡'" } },
	".cm-completionIcon-enum": { "&:after": { content: "'∪'" } },
	".cm-completionIcon-property": { "&:after": { content: "'□'" } },
	".cm-completionIcon-keyword": { "&:after": { content: "'🔑︎'" } },
	".cm-completionIcon-namespace": { "&:after": { content: "'▢'" } },
	".cm-completionIcon-text": { "&:after": {
		content: "'abc'",
		fontSize: "50%",
		verticalAlign: "middle"
	} }
}), Ie = class {
	constructor(e, t, n, r) {
		this.field = e, this.line = t, this.from = n, this.to = r;
	}
}, Le = class e {
	constructor(e, t, n) {
		this.field = e, this.from = t, this.to = n;
	}
	map(t) {
		let n = t.mapPos(this.from, -1, f.TrackDel), r = t.mapPos(this.to, 1, f.TrackDel);
		return n == null || r == null ? null : new e(this.field, n, r);
	}
}, Re = class e {
	constructor(e, t) {
		this.lines = e, this.fieldPositions = t;
	}
	instantiate(e, t) {
		let n = [], r = [t], i = e.doc.lineAt(t), a = /^\s*/.exec(i.text)[0];
		for (let i of this.lines) {
			if (n.length) {
				let n = a, o = /^\t*/.exec(i)[0].length;
				for (let t = 0; t < o; t++) n += e.facet(p);
				r.push(t + n.length - o), i = n + i.slice(o);
			}
			n.push(i), t += i.length + 1;
		}
		return {
			text: n,
			ranges: this.fieldPositions.map((e) => new Le(e.field, r[e.line] + e.from, r[e.line] + e.to))
		};
	}
	static parse(t) {
		let n = [], r = [], i = [], a;
		for (let e of t.split(/\r\n?|\n/)) {
			for (; a = /[#$]\{(?:(\d+)(?::([^{}]*))?|((?:\\[{}]|[^{}])*))\}/.exec(e);) {
				let t = a[1] ? +a[1] : null, o = a[2] || a[3] || "", s = -1;
				t === 0 && (t = 1e9);
				let c = o.replace(/\\[{}]/g, (e) => e[1]);
				for (let e = 0; e < n.length; e++) (t == null ? c && n[e].name == c : n[e].seq == t) && (s = e);
				if (s < 0) {
					let e = 0;
					for (; e < n.length && (t == null || n[e].seq != null && n[e].seq < t);) e++;
					n.splice(e, 0, {
						seq: t,
						name: c
					}), s = e;
					for (let e of i) e.field >= s && e.field++;
				}
				for (let e of i) if (e.line == r.length && e.from > a.index) {
					let t = a[2] ? 3 + (a[1] || "").length : 2;
					e.from -= t, e.to -= t;
				}
				i.push(new Ie(s, r.length, a.index, a.index + c.length)), e = e.slice(0, a.index) + o + e.slice(a.index + a[0].length);
			}
			e = e.replace(/\\([{}])/g, (e, t, n) => {
				for (let e of i) e.line == r.length && e.from > n && (e.from--, e.to--);
				return t;
			}), r.push(e);
		}
		return new e(r, i);
	}
}, ze = /*@__PURE__*/ m.widget({ widget: /*@__PURE__*/ new class extends ee {
	toDOM() {
		let e = document.createElement("span");
		return e.className = "cm-snippetFieldPosition", e;
	}
	ignoreEvent() {
		return !1;
	}
}() }), Be = /*@__PURE__*/ m.mark({ class: "cm-snippetField" }), W = class e {
	constructor(e, t) {
		this.ranges = e, this.active = t, this.deco = m.set(e.map((e) => (e.from == e.to ? ze : Be).range(e.from, e.to)), !0);
	}
	map(t) {
		let n = [];
		for (let e of this.ranges) {
			let r = e.map(t);
			if (!r) return null;
			n.push(r);
		}
		return new e(n, this.active);
	}
	selectionInsideField(e) {
		return e.ranges.every((e) => this.ranges.some((t) => t.field == this.active && t.from <= e.from && t.to >= e.to));
	}
}, G = /*@__PURE__*/ i.define({ map(e, t) {
	return e && e.map(t);
} }), Ve = /*@__PURE__*/ i.define(), K = /*@__PURE__*/ d.define({
	create() {
		return null;
	},
	update(e, t) {
		for (let n of t.effects) {
			if (n.is(G)) return n.value;
			if (n.is(Ve) && e) return new W(e.ranges, n.value);
		}
		return e && t.docChanged && (e = e.map(t.changes)), e && t.selection && !e.selectionInsideField(t.selection) && (e = null), e;
	},
	provide: (e) => o.decorations.from(e, (e) => e ? e.deco : m.none)
});
function q(e, t) {
	return w.create(e.filter((e) => e.field == t).map((e) => w.range(e.from, e.to)));
}
function He(e) {
	let t = Re.parse(e);
	return (e, r, a, o) => {
		let { text: s, ranges: c } = t.instantiate(e.state, a), { main: l } = e.state.selection, u = {
			changes: {
				from: a,
				to: o == l.from ? l.to : o,
				insert: b.of(s)
			},
			scrollIntoView: !0,
			annotations: r ? [k.of(r), n.userEvent.of("input.complete")] : void 0
		};
		if (c.length && (u.selection = q(c, 0)), c.some((e) => e.field > 0)) {
			let t = new W(c, 0), n = u.effects = [G.of(t)];
			e.state.field(K, !1) === void 0 && n.push(i.appendConfig.of([
				K,
				Ge,
				qe,
				U
			]));
		}
		e.dispatch(e.state.update(u));
	};
}
function J(e) {
	return ({ state: t, dispatch: n }) => {
		let r = t.field(K, !1);
		if (!r || e < 0 && r.active == 0) return !1;
		let i = r.active + e, a = e > 0 && !r.ranges.some((t) => t.field == i + e);
		return n(t.update({
			selection: q(r.ranges, i),
			effects: G.of(a ? null : new W(r.ranges, i)),
			scrollIntoView: !0
		})), !0;
	};
}
var Ue = [{
	key: "Tab",
	run: /* @__PURE__ */ J(1),
	shift: /* @__PURE__ */ J(-1)
}, {
	key: "Escape",
	run: ({ state: e, dispatch: t }) => e.field(K, !1) ? (t(e.update({ effects: G.of(null) })), !0) : !1
}], We = /*@__PURE__*/ C.define({ combine(e) {
	return e.length ? e[0] : Ue;
} }), Ge = /*@__PURE__*/ r.highest(/*@__PURE__*/ v.compute([We], (e) => e.facet(We)));
function Ke(e, t) {
	return {
		...t,
		apply: He(e)
	};
}
var qe = /*@__PURE__*/ o.domEventHandlers({ mousedown(e, t) {
	let n = t.state.field(K, !1), r;
	if (!n || (r = t.posAtCoords({
		x: e.clientX,
		y: e.clientY
	})) == null) return !1;
	let i = n.ranges.find((e) => e.from <= r && e.to >= r);
	return !i || i.field == n.active ? !1 : (t.dispatch({
		selection: q(n.ranges, i.field),
		effects: G.of(n.ranges.some((e) => e.field > i.field) ? new W(n.ranges, i.field) : null),
		scrollIntoView: !0
	}), !0);
} }), Y = {
	brackets: [
		"(",
		"[",
		"{",
		"'",
		"\""
	],
	before: ")]}:;>",
	stringPrefixes: []
}, X = /*@__PURE__*/ i.define({ map(e, t) {
	return t.mapPos(e, -1, f.TrackAfter) ?? void 0;
} }), Z = /*@__PURE__*/ new class extends a {}();
Z.startSide = 1, Z.endSide = -1;
var Je = /*@__PURE__*/ d.define({
	create() {
		return te.empty;
	},
	update(e, t) {
		if (e = e.map(t.changes), t.selection) {
			let n = t.state.doc.lineAt(t.selection.main.head);
			e = e.update({ filter: (e) => e >= n.from && e <= n.to });
		}
		for (let n of t.effects) n.is(X) && (e = e.update({ add: [Z.range(n.value, n.value + 1)] }));
		return e;
	}
});
function Ye() {
	return [$e, Je];
}
var Q = "()[]{}<>«»»«［］｛｝";
function Xe(e) {
	for (let t = 0; t < 16; t += 2) if (Q.charCodeAt(t) == e) return Q.charAt(t + 1);
	return s(e < 128 ? e : e + 1);
}
function Ze(e, t) {
	return e.languageDataAt("closeBrackets", t)[0] || Y;
}
var Qe = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent), $e = /*@__PURE__*/ o.inputHandler.of((e, t, n, r) => {
	if ((Qe ? e.composing : e.compositionStarted) || e.state.readOnly) return !1;
	let i = e.state.selection.main;
	if (r.length > 2 || r.length == 2 && l(y(r, 0)) == 1 || t != i.from || n != i.to) return !1;
	let a = tt(e.state, r);
	return a ? (e.dispatch(a), !0) : !1;
}), et = [{
	key: "Backspace",
	run: ({ state: e, dispatch: t }) => {
		if (e.readOnly) return !1;
		let n = Ze(e, e.selection.main.head).brackets || Y.brackets, r = null, i = e.changeByRange((t) => {
			if (t.empty) {
				let r = rt(e.doc, t.head);
				for (let i of n) if (i == r && $(e.doc, t.head) == Xe(y(i, 0))) return {
					changes: {
						from: t.head - i.length,
						to: t.head + i.length
					},
					range: w.cursor(t.head - i.length)
				};
			}
			return { range: r = t };
		});
		return r || t(e.update(i, {
			scrollIntoView: !0,
			userEvent: "delete.backward"
		})), !r;
	}
}];
function tt(e, t) {
	let n = Ze(e, e.selection.main.head), r = n.brackets || Y.brackets;
	for (let i of r) {
		let a = Xe(y(i, 0));
		if (t == i) return a == i ? ot(e, i, r.indexOf(i + i + i) > -1, n) : it(e, i, a, n.before || Y.before);
		if (t == a && nt(e, e.selection.main.from)) return at(e, i, a);
	}
	return null;
}
function nt(e, t) {
	let n = !1;
	return e.field(Je).between(0, e.doc.length, (e) => {
		e == t && (n = !0);
	}), n;
}
function $(e, t) {
	let n = e.sliceString(t, t + 2);
	return n.slice(0, l(y(n, 0)));
}
function rt(e, t) {
	let n = e.sliceString(t - 2, t);
	return l(y(n, 0)) == n.length ? n : n.slice(1);
}
function it(e, t, n, r) {
	let i = null, a = e.changeByRange((a) => {
		if (!a.empty) return {
			changes: [{
				insert: t,
				from: a.from
			}, {
				insert: n,
				from: a.to
			}],
			effects: X.of(a.to + t.length),
			range: w.range(a.anchor + t.length, a.head + t.length)
		};
		let o = $(e.doc, a.head);
		return !o || /\s/.test(o) || r.indexOf(o) > -1 ? {
			changes: {
				insert: t + n,
				from: a.head
			},
			effects: X.of(a.head + t.length),
			range: w.cursor(a.head + t.length)
		} : { range: i = a };
	});
	return i ? null : e.update(a, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function at(e, t, n) {
	let r = null, i = e.changeByRange((t) => t.empty && $(e.doc, t.head) == n ? {
		changes: {
			from: t.head,
			to: t.head + n.length,
			insert: n
		},
		range: w.cursor(t.head + n.length)
	} : r = { range: t });
	return r ? null : e.update(i, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function ot(e, t, n, r) {
	let i = r.stringPrefixes || Y.stringPrefixes, a = null, o = e.changeByRange((r) => {
		if (!r.empty) return {
			changes: [{
				insert: t,
				from: r.from
			}, {
				insert: t,
				from: r.to
			}],
			effects: X.of(r.to + t.length),
			range: w.range(r.anchor + t.length, r.head + t.length)
		};
		let o = r.head, s = $(e.doc, o), c;
		if (s == t) {
			if (st(e, o)) return {
				changes: {
					insert: t + t,
					from: o
				},
				effects: X.of(o + t.length),
				range: w.cursor(o + t.length)
			};
			if (nt(e, o)) {
				let r = n && e.sliceDoc(o, o + t.length * 3) == t + t + t ? t + t + t : t;
				return {
					changes: {
						from: o,
						to: o + r.length,
						insert: r
					},
					range: w.cursor(o + r.length)
				};
			}
		} else if (n && e.sliceDoc(o - 2 * t.length, o) == t + t && (c = lt(e, o - 2 * t.length, i)) > -1 && st(e, c)) return {
			changes: {
				insert: t + t + t + t,
				from: o
			},
			effects: X.of(o + t.length),
			range: w.cursor(o + t.length)
		};
		else if (e.charCategorizer(o)(s) != g.Word && lt(e, o, i) > -1 && !ct(e, o, t, i)) return {
			changes: {
				insert: t + t,
				from: o
			},
			effects: X.of(o + t.length),
			range: w.cursor(o + t.length)
		};
		return { range: a = r };
	});
	return a ? null : e.update(o, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function st(e, n) {
	let r = t(e).resolveInner(n + 1);
	return r.parent && r.from == n;
}
function ct(e, n, r, i) {
	let a = t(e).resolveInner(n, -1), o = i.reduce((e, t) => Math.max(e, t.length), 0);
	for (let t = 0; t < 5; t++) {
		let t = e.sliceDoc(a.from, Math.min(a.to, a.from + r.length + o)), s = t.indexOf(r);
		if (!s || s > -1 && i.indexOf(t.slice(0, s)) > -1) {
			let t = a.firstChild;
			for (; t && t.from == a.from && t.to - t.from > r.length + s;) {
				if (e.sliceDoc(t.to - r.length, t.to) == r) return !1;
				t = t.firstChild;
			}
			return !0;
		}
		let c = a.to == n && a.parent;
		if (!c) break;
		a = c;
	}
	return !1;
}
function lt(e, t, n) {
	let r = e.charCategorizer(t);
	if (r(e.sliceDoc(t - 1, t)) != g.Word) return t;
	for (let i of n) {
		let n = t - i.length;
		if (e.sliceDoc(n, t) == i && r(e.sliceDoc(n - 1, n)) != g.Word) return n;
	}
	return -1;
}
function ut(e = {}) {
	return [
		Fe,
		z,
		M.of(e),
		Ne,
		ft,
		U
	];
}
var dt = [
	{
		key: "Ctrl-Space",
		run: H
	},
	{
		mac: "Alt-`",
		run: H
	},
	{
		mac: "Alt-i",
		run: H
	},
	{
		key: "Escape",
		run: ke
	},
	{
		key: "ArrowDown",
		run: /*@__PURE__*/ V(!0)
	},
	{
		key: "ArrowUp",
		run: /*@__PURE__*/ V(!1)
	},
	{
		key: "PageDown",
		run: /*@__PURE__*/ V(!0, "page")
	},
	{
		key: "PageUp",
		run: /*@__PURE__*/ V(!1, "page")
	},
	{
		key: "Enter",
		run: Oe
	}
], ft = /*@__PURE__*/ r.highest(/*@__PURE__*/ v.computeN([M], (e) => e.facet(M).defaultKeymap ? [dt] : []));
//#endregion
export { D as a, Ke as c, et as i, ut as n, dt as o, Ye as r, re as s, T as t };

//# sourceMappingURL=dist-CwwjEPEF.js.map